import React from 'react'
import {Col, Badge, Label} from 'reactstrap'
import {Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import {ModelListTable} from '../../ui'
import {getAllUsers, WS_URL} from '../../../api'
import Websocket from "react-websocket"

import {User, AppError} from "../../../models"
import {pageHelpers} from "../"
import UserIcon from "react-icons/lib/fa/user"
import ManageAccountIcon from "react-icons/lib/fa/wrench"

import '../../../stylesheets/Search.css'

const MANAGE_ACCOUNT_FIELD_NAME = "-"

let manageAccountLinkGenerator = (user) => {
    return <Link to={`/users/${user.id}`}>
        <Badge className="p-2 bg-light-sf-blue">
            <ManageAccountIcon className="d-none d-md-inline-block mr-2"/>
            <span className="d-inline-block d-md-none">MNG</span>
            <span className="d-none d-md-inline-block">Manage</span>
        </Badge>
    </Link>
}

class SearchPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token} = props

        this.state = {
            token,
            loading: false,
            errors: [],
            users: [],
        }

        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchUsers = this.fetchUsers.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        const {token} = nextProps
        pageHelpers.setupPropsForPage(nextProps, this)
        if (token) {
            await this.setState({token, loading: true})
            await this.fetchUsers()
            this.setState({loading: false})
        }
    }

    async componentDidMount() {
        if (this.state.token) {
            this.setState({loading: true})
            await this.fetchUsers()
            this.setState({loading: false})
        }
    }


    async fetchUsers() {
        let {token} = this.state
        try {
            let {results} = await getAllUsers(token, true, 1, 100000)
            this.setState({users:results})
        } catch(err) {
            console.log(err)
            let appError = new AppError("Failed to Get Users", err.message)
            this.setState({errors:[appError]})
        }
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let updatedUser = User.fromAPIObject(result)
        let {users} = this.state
        let filteredUsers = users.filter((u) => u.id !== updatedUser.id)
        if (filteredUsers.length < users.length) {
            users = filteredUsers
            users.push(updatedUser)
            this.setState({users})
        }
    }

    render() {
        let {errors, token, users, loading} = this.state

        let fixedCharacterWidthFields = {_group: 6, teams: 4.6, email: 11, name: 13}
        fixedCharacterWidthFields[MANAGE_ACCOUNT_FIELD_NAME] = [4.5, 6]
        let fieldContentGenerators = {}
        fieldContentGenerators[MANAGE_ACCOUNT_FIELD_NAME] = manageAccountLinkGenerator

        let count = (users && users.length ? users.length : 0)
        let customerCount = (users && users.length ? users.filter(u=>!u.isDealer && !u.isSupport).length : 0)
        let dealerCount = (users && users.length ? users.filter(u=>u.isDealer && !u.isSupport).length : 0)
        let supportCount = (users && users.length ? users.filter(u=>u.isSupport).length : 0)

        return (
            <Col xs={12} className="text-center">
                <h1 className="col-12 no-gutters mb-2 d-block d-sm-none light-sf-orange font-weight-bold p-0"><UserIcon
                    className="light-sf-blue mr-2"/>Search Users</h1>
                <h1 className="col-12 no-gutters mb-2 d-none d-sm-block light-sf-orange font-weight-bold"><UserIcon
                    className="light-sf-blue mr-2"/>Search All Users</h1>
                <p className="col-12 mb-4">
                </p>

                {count && !loading ?
                    <Label className="small text-secondary col-12 text-left">
                        {count} Users &mdash; {customerCount} Customers &mdash; {dealerCount} Dealers &mdash; {supportCount} Support
                    </Label>:
                        null}

                {loading ?
                    <Col xs={12} className="text-center m-4">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </Col> :
                    <ModelListTable models={users}
                                    fields={["_group", "name", "email", "teams", MANAGE_ACCOUNT_FIELD_NAME]}
                                    searchFields={["name", "email"]}
                                    boldFields={["name"]}
                                    hideableFields={["_group", "email", "teams",]}
                                    leftAlignFields={["name", "email", "_group"]}
                                    fixedCharacterWidthFields={fixedCharacterWidthFields}
                                    fieldContentGenerators={fieldContentGenerators}
                                    className="p-0"/>}

                {token && users && !loading ?
                    users.map((t, idx) =>
                        <Websocket key={`ws-${t.id}-${idx}`}
                                    url={`${WS_URL}/users/${t.id}/?access_token=${token.accessToken}`}
                                   onMessage={this.handleWebSocketResponse}/>
                    ):
                        null}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
            </Col>)
    }
}

export default SearchPage



// WEBPACK FOOTER //
// ./src/components/pages/users/SearchPage.js